var _rect, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgNewVehicle = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "add_new_vehicle",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 46,
    height: 46,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28292",
    "data-name": "Group 28292"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12946",
    "data-name": "Rectangle 12946",
    width: 6,
    height: 2,
    transform: "translate(8 23)",
    fill: "#d7272f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61199",
    "data-name": "Path 61199",
    d: "M38.8,15,34.5,7.7A5.543,5.543,0,0,0,29.6,5H16.4a5.661,5.661,0,0,0-4.9,2.7L7.2,15H2v2H5.3A5.6,5.6,0,0,0,4,20.5v8.9a3.74,3.74,0,0,0,1,2.5v3.7A3.335,3.335,0,0,0,8.2,39h4.5a3.27,3.27,0,0,0,3.2-3.4V33h8V31H16.3l1.8-2.9A2.367,2.367,0,0,1,20,27h4V25H20.2a4.2,4.2,0,0,0-3.6,2l-2.5,4H7.6A1.58,1.58,0,0,1,6,29.4V20.5A3.543,3.543,0,0,1,9.5,17H36.4a3.543,3.543,0,0,1,3.5,3.5V23h2V20.5A5.39,5.39,0,0,0,40.6,17H44V15ZM7,32.9a1.268,1.268,0,0,0,.6.1H14v2.6A1.337,1.337,0,0,1,12.8,37H8.2A1.337,1.337,0,0,1,7,35.6ZM9.5,15l3.7-6.3A3.837,3.837,0,0,1,16.4,7H29.7a3.659,3.659,0,0,1,3.1,1.7L36.5,15Z",
    fill: "#d7272f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61200",
    "data-name": "Path 61200",
    d: "M36,28H34v3H31v2h3v3h2V33h3V31H36Z",
    fill: "#d7272f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61201",
    "data-name": "Path 61201",
    d: "M35,23a9,9,0,1,0,9,9A8.963,8.963,0,0,0,35,23Zm0,16a7,7,0,1,1,7-7A6.957,6.957,0,0,1,35,39Z",
    fill: "#d7272f"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewVehicle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new-vehicle.2c8a3f0c.svg";
export { ForwardRef as ReactComponent };